<div class="container">
    <div class="action-header space-between row w100 gap-24">
        <div class="row gap-8">
            <rr-btn
                size="small"
                type="Secondary"
                *ngIf="!isEditing"
                iconStart="miro"
                (click)="miroExport()"
                >Miro Export</rr-btn
            >
            <rr-btn
                size="small"
                type="Secondary"
                *ngIf="!isEditing"
                iconStart="pdf"
                (click)="downloadAsPdf()"
                >Download PDF</rr-btn
            >
        </div>
        <div class="row gap-8">
            @if (!data.isCoachAccess) {
            <rr-btn
                size="small"
                (btnclick)="toggleEdit()"
                type="Secondary"
                [iconStart]="isEditing ? 'check' : 'edit'"
                >{{ isEditing ? "Save" : "Edit" }}</rr-btn
            >
            }
            <rr-btn
                iconStart="close"
                size="small"
                type="Secondary"
                (btnclick)="close()"
                >{{ isEditing ? "Cancel" : "Close" }}</rr-btn
            >
        </div>
    </div>
    <div class="preview">
        <div class="preview-header">
            <img src="images/logo_name.svg" />
            <h3>{{ data.name }}</h3>
        </div>
        <div class="preview-content">
            @if(data.variant === "CLS_BMC"){
            <app-template-bmc
                [data]="data.data"
                [state]="isEditing"
            ></app-template-bmc>
            }@else {
            <app-template-keyquestions
                [data]="data.data"
                [state]="isEditing"
            ></app-template-keyquestions>
            }
        </div>
    </div>
</div>
<rr-spinner *ngIf="isLoading"></rr-spinner>
